import { BaseModel } from "./base.model";
import { CompanyModel } from "./company.model";
import { ImageModel } from "./image.model";

export class ProfileModel extends BaseModel {
    static SOURCE_INSTANCE = 'instance';

    id: number;
    personalTitle: string;
    firstName: string;
    lastName: string;
    language: string;
    email: string;
    phone: string;
    image: ImageModel;
    companyId: number;
    externalId: string;
    source: string;
    isAdmin: boolean;
    canBeDeleted: boolean;

    company: CompanyModel

    get childModels(): {} {
        return {
            image: ImageModel,
            company: CompanyModel,
        };
    }
}
